module.exports = __webpack_public_path__ + "img/freshest-flick-malay.cd434c43.png";